/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';

import ProductSlider from '../SliderLib/ProductSlider/components/ProductSlider';
import client from '../utils/client';
import viewItemList from '../utils/ga4/viewItemList';
import getUid from '../utils/snowplow';
import uuid4 from '../utils/uuid';

const ALGORITHM_ITEM_LISTS = {
  'more-like-this': { id: 'related_products', name: 'Related Products' },
  'popular-products': { id: 'popular_products', name: 'Popular Products' }
};

/**
 * Resolve the GA4 item list for the page context this slider is mounted on.
 * `window.campaign_data` is only set on campaign pages (campaign.html).
 *
 * @param {string} algorithm
 * @returns {{ id: string, name: string }}
 */
const getItemList = algorithm => {
  if (window.campaign_data) {
    return { id: 'campaign_products', name: 'Campaign Products' };
  }
  return (
    ALGORITHM_ITEM_LISTS[algorithm] || {
      id: 'product_slider',
      name: 'Product Slider'
    }
  );
};

export default class ProductSliderContainer extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      refId: uuid4(),
      items: [],
      loading: false,
      loaded: false
    };
  }

  componentDidMount() {
    if (
      'IntersectionObserver' in window &&
      'IntersectionObserverEntry' in window &&
      'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
      // Create intersectionObserver
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      const observer = new window.IntersectionObserver(this.callback, options);
      const target = this.ref.current;
      observer.observe(target);
    } else {
      this.loadItems();
    }
  }

  // this method is faulty on iOS until future investigation it will be commented
  // componentDidUpdate(prevProps) {
  //   if (this.props.algorithmOptions !== prevProps.algorithmOptions) {
  //     this.setState({
  //       refId: uuid4(),
  //       loaded: false,
  //     }, () => {
  //       this.loadItems();
  //     });
  //   }
  // }

  callback = (entries, observer) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        this.loadItems();
        if (observer) {
          observer.disconnect();
        }
      }
    });
  };

  loadItems() {
    if (this.state.loaded || this.state.loading) {
      return;
    }
    this.setState({ loading: true });

    let recommendationsFetch;
    if (this.props.algorithm === 'product-list') {
      recommendationsFetch = client.get(`/api/products/batch/`, {
        params: { list: this.props.algorithmOptions.productIds.join(',') }
      });
    } else {
      recommendationsFetch = client.get(
        `/api/recommendations/${this.props.algorithm}/`,
        {
          params: {
            ...this.props.algorithmOptions
          }
        }
      );
    }

    recommendationsFetch.then(recommendations => {
      // There's a slight difference in the responses between the recommendation APIs and the batch product list.
      const products = recommendations.data.data
        ? recommendations.data.data.results
        : recommendations.data.products;
      const productIds = products.map(i => i.product_id);
      if (products.length > 0) {
        if (window.ua) {
          window.ua(
            'trackStructEvent',
            'slider',
            'display',
            this.state.refId,
            productIds
          );
        }
        const { algorithm } = this.props;
        const itemList = getItemList(algorithm);
        viewItemList(products, itemList.id, itemList.name);
        this.setState({
          items: products,
          loaded: true,
          loading: false
        });
      }
    });
  }

  render() {
    const titleElement = this.props.title ? (
      <h2 className="sliderHeader">{this.props.title}</h2>
    ) : (
      ''
    );
    const { algorithm } = this.props;
    const itemList = getItemList(algorithm);
    return (
      <div ref={this.ref}>
        {this.state.items.length > 0 && (
          <div>
            {titleElement}
            <ProductSlider
              refId={this.state.refId}
              products={this.state.items}
              // addToCartForm={this.props.addToCartForm}
              sliderType={this.props.algorithm}
              productClick={this.props.productClick}
              itemListId={itemList.id}
              itemListName={itemList.name}
            />
          </div>
        )}
      </div>
    );
  }
}

if (window.productSliders) {
  window.productSliders.forEach(productSlider => {
    ReactDOM.render(
      <ProductSliderContainer
        title={productSlider.title}
        algorithm={productSlider.algorithm}
        algorithmOptions={productSlider.algorithmOptions}
        // addToCartForm={productSlider.addToCartForm}
      />,
      productSlider.mountPoint
    );
  });
}
